import { firebase } from '../config/configureFirebase';

// H4 Faz B: /googleapi now requires a Bearer Firebase ID token (or legacy Basic
// transitionally — kept on the server until Faz C). All callers below switched
// to Bearer so we can drop Basic + AccessKey in Faz C.
async function getAuthHeader() {
    const { auth } = firebase;
    const user = auth && auth.currentUser;
    if (!user) {
        throw new Error('Not authenticated');
    }
    const token = await user.getIdToken();
    return 'Bearer ' + token;
}

async function postGoogleApi(body) {
    const { config } = firebase;
    const authz = await getAuthHeader();
    const r = await fetch(`https://${config.projectId}.web.app/googleapi`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': authz,
        },
        body: JSON.stringify(body),
    });
    return r.json();
}

// sec-api-hardening: /gettranslation is now admin-only (Bearer ID token). The
// admin LanguageSetting screen calls this instead of an unauthenticated fetch.
export const fetchTranslation = async (str, from, to) => {
    const { config } = firebase;
    const authz = await getAuthHeader();
    const url = `https://${config.projectId}.web.app/gettranslation?str=${encodeURIComponent(str)}&from=${encodeURIComponent(from || 'en')}&to=${encodeURIComponent(to)}`;
    const r = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': authz,
        },
    });
    return r.json();
};

export const fetchPlacesAutocomplete = (searchKeyword) => {
    return new Promise((resolve, reject) => {
        postGoogleApi({ searchKeyword })
            .then(json => {
                if (json && json.searchResults) resolve(json.searchResults);
                else reject(json && json.error);
            })
            .catch(err => {
                console.log(err);
                reject('fetchPlacesAutocomplete Call Error');
            });
    });
};

export const fetchCoordsfromPlace = (place_id) => {
    return new Promise((resolve, reject) => {
        postGoogleApi({ place_id })
            .then(json => {
                if (json && json.coords) resolve(json.coords);
                else reject(json && json.error);
            })
            .catch(err => {
                console.log(err);
                reject('fetchCoordsfromPlace Call Error');
            });
    });
};

export const fetchAddressfromCoords = (latlng) => {
    return new Promise((resolve, reject) => {
        postGoogleApi({ latlng })
            .then(json => {
                if (json && json.address) resolve(json.address);
                else reject(json && json.error);
            })
            .catch(err => {
                console.log(err);
                reject('fetchAddressfromCoords Call Error');
            });
    });
};

export const getDistanceMatrix = (startLoc, destLoc) => {
    return new Promise((resolve, reject) => {
        postGoogleApi({ start: startLoc, dest: destLoc, calltype: 'matrix' })
            .then(json => {
                if (json && json.error) {
                    console.log(json.error);
                    reject(json.error);
                } else {
                    resolve(json);
                }
            })
            .catch(err => {
                console.log(err);
                reject('getDistanceMatrix Call Error');
            });
    });
};

export const getDirectionsApi = (startLoc, destLoc, waypoints) => {
    return new Promise((resolve, reject) => {
        const body = { start: startLoc, dest: destLoc, calltype: 'direction' };
        if (waypoints) body.waypoints = waypoints;
        postGoogleApi(body)
            .then(json => {
                if (json && Object.prototype.hasOwnProperty.call(json, 'distance_in_km')) {
                    resolve(json);
                } else {
                    console.log(json && json.error);
                    reject(json && json.error);
                }
            })
            .catch(err => {
                console.log(err);
                reject('getDirectionsApi Call Error');
            });
    });
};
